/**
 * Component: Mobile footer naviation
 * -----------------------------------------------------------------------------
 * This element is a navigation bar on that display on scroll up.
 *
 * @namespace MobileFooterNav
 */

import ScrollDirection from '../mixins/scroll-direction';
import cssClasses from '../helpers/cssClasses';

/**
 * Export default mobile footer navigation
 */
export default () => {
  function init() {
    constructStickyFooter();
    setListeners();
  }

  /**
   * Instantiate a collapsed header on scroll using scrollDirection helper.
   */
  function constructStickyFooter() {
    const AnimatedFooter = ScrollDirection({
      throttle: 50,
      start: 0,
    }).init();
  }

  /**
   * Set listeners based on scroll direction.
   */
  function setListeners() {
    const footeNavbar = document.querySelector('.custom-nav');

    Karmoon.EventBus.listen('ScrollDirection:down', () => {
      footeNavbar.classList.remove(cssClasses.active);
    });

    Karmoon.EventBus.listen('ScrollDirection:up', () => {
      footeNavbar.classList.add(cssClasses.active);
    });

    Karmoon.EventBus.listen('ScrollDirection:top', () => {
      footeNavbar.classList.add(cssClasses.active);
    });
  }

  /**
   * Public interface.
   */
  return Object.freeze({
    init,
  });
};
